<script>
import SquareImage from '@/components/SquareImage.vue'

export default {
  components: { SquareImage },
  data() {
    return {
      directions: [
        {
          title: 'COMMERCIAL',
          link: 'commercial',
          image_url: '/static/img/commercial_cover.webp',
          alt: 'Коммерческое видео и реклама — обложка направления',
        },
        {
          title: '3D | MOTION',
          link: '3d',
          image_url: '/static/img/3D_cover.webp',
          alt: '3D и motion-дизайн — обложка направления',
        },
        {
          title: 'DESIGN DEVELOPMENT',
          link: 'develop',
          image_url: '/static/img/development.png',
          alt: 'Дизайн и разработка — обложка направления',
        },
        {
          title: 'BROADCAST',
          link: 'broadcast',
          image_url: '/static/img/broadcast_cover.webp',
          alt: 'Broadcast и трансляции — обложка направления',
          hideOnDesktop: true,
        },
        // {
        //     title: "ART",
        //     link: "art",
        //    image_url: "/static/img/art_cover.webp"
        // }
      ],
    }
  },
}
</script>

<template>
  <div class="flex flex-center">
    <div class="container grid">
      <template v-if="isMobile">
        <a
          v-for="direction in directions"
          :key="direction.link"
          :href="direction.link"
          class="direction-link"
          :class="{ 'direction-hide-desktop': direction.hideOnDesktop }"
        >
          <span class="direction-title">
            <template v-if="direction.link === 'develop'">
              <span class="direction-title-main direction-title-main--design">DESIGN </span>
              <span class="direction-title-secondary">DEVELOPMENT</span>
            </template>
            <template v-else>
              {{ direction.title }}
            </template>
            <span class="arrow">→</span>
          </span>
        </a>
      </template>
      <template v-else>
        <template v-for="(direction, index) in directions" :key="direction.link">
          <SquareImage
            v-if="!(direction.hideOnDesktop && isDesktop)"
            style_main
            :image_url="direction.image_url"
            :title="direction.title"
            :alt="direction.alt"
            :link="direction.link"
            :eager="true"
            :high-priority="index === 0"
            :class="{ 'direction-production': direction.link === 'develop' }"
          />
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const isMobile = ref(window.innerWidth < 360)
const windowWidth = ref(window.innerWidth)

window.addEventListener('resize', () => {
  isMobile.value = window.innerWidth < 360
  windowWidth.value = window.innerWidth
})

const isDesktop = computed(() => windowWidth.value >= 1024)
</script>

<style scoped>
.container {
  width: 100%;
  /*grid-template-columns: repeat(2, calc(50% - 0.938rem));*/
  /*grid-template-columns: repeat(4, calc(25% - 1.563rem));*/
  grid-template-columns: repeat(3, calc(33% - 1.2rem));
  grid-template-rows: auto;
  grid-column-gap: 2.188rem;
}

.direction-link {
  width: 100%;
  text-decoration: none;
  color: #000;
  padding: 0.625rem 0;
  display: block;
  font-size: 1.5em;
  font-weight: bold;
}

.direction-title {
  line-height: 1.1;
}

.direction-title-main--design {
  display: inline;
}

.arrow {
  margin-left: 0.313rem;
  font-size: 1.5em;
  font-weight: bold;
}

.squareImage {
  width: 100%;
  height: auto;
}

@media (max-width: 87.5rem) {
  .container {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 1.25rem;
  }
}

@media (max-width: 64rem) {
  .container {
    justify-content: center;
    align-content: center;
    grid-template-columns: repeat(2, calc(50% - 0.625rem));
    grid-template-rows: auto;
    grid-column-gap: 1.25rem;
    grid-row-gap: 1.25rem;
  }
}

@media (max-width: 36rem) {
  .container {
    grid-template-columns: 100%;
    grid-template-rows: auto;
    grid-column-gap: 0.625rem;
    grid-row-gap: 0.375rem;
  }

  .direction-link {
    padding: 0.375rem 0;
  }
}

@media (max-width: 20rem) {
  .container {
    grid-template-columns: 100%;
    grid-template-rows: auto;
    grid-column-gap: 0.625rem;
    grid-row-gap: 0.25rem;
  }

  .direction-title {
    font-size: 1.5em;
  }

  .direction-link {
    font-size: 1.2em;
    padding: 0.25rem 0;
    min-height: 4.2rem;
  }

  .direction-title-main--design {
    display: none;
  }
}

@media (max-width: 22.5rem) {
  .container {
    grid-row-gap: 0.25rem;
  }

  .direction-link {
    padding: 0.375rem 0;
    min-height: 3rem;
  }
}

.container :deep(.square-image-root),
.container :deep(.square-image-inner),
.container :deep(.image-square) {
  min-height: 15rem;
}

.direction-production :deep(.image-square_text) {
  text-align: center !important;
  justify-content: center !important;
  align-items: center !important;
}

.direction-production :deep(.image-square_text span) {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin: 0 auto !important;
  text-align-last: center !important;
}

@media (min-width: 64rem) {
  .direction-production :deep(.image-square_text) {
    text-align: center !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .direction-production :deep(.image-square_text span) {
    text-align: center !important;
    display: block !important;
    width: 100% !important;
    margin: 0 auto !important;
    text-align-last: center !important;
  }
}
</style>
